<template>
  <div id="pmlst-quiz">
    <div class="pmlst-quiz-wrapper">
      <text-pane v-if="showTextpane">
        <span v-html="textpane"></span>
      </text-pane>
      <div id="pmlst-questions">
        <pure-step-tracker :steptracker="steptracker" />
        <div class="questions">
          <pure-question-list :questionlist="questionlist" />
        </div>
        <div class="actions">
          <div class="actions-wrapper">
            <div><back-button v-if="showBackButton" /></div>
            <div><restart-button /></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextPane from '@/components/TextPane'
import PureQuestionList from '@/components/PureQuestionList'
import RestartButton from '@/components/RestartButton'
import PureStepTracker from '@/components/PureStepTracker'
import BackButton from '@/components/BackButton'

export default {
  name: 'pure-quiz-screen',
  components: {
    TextPane,
    PureQuestionList,
    RestartButton,
    PureStepTracker,
    BackButton
  },
  props: {
    quiz: {
      type: Object,
      required: true
    }
  },
  computed: {
    textpane() {
      return this.$props.quiz.showtextpane ? this.$props.quiz.textpane : null
    },
    questionlist() {
      return this.$props.quiz.questionlist
    },
    steptracker() {
      return this.$store.getters.getSteptrackerState
    },
    showTextpane() {
      return this.$props.quiz.showtextpane
    },
    showBackButton() {
      return this.$props.quiz.questionlist.questions.length > 1 ? true : false
    }
  }
}
</script>
